import React from "react";
import withContext from "../utils/withContext";

export class AdFoxAdaptive extends React.Component {
    componentDidMount() {

            const opts = [...this.props.options]
            opts[0].params["partner-stat-id"] = this.props.context.uniq_id
            window.yaContextCb.push(()=>{
                window.Ya.adfoxCode.create(...opts);
            });
    }

    render() {
        const { options, cls = true } = this.props;
        return <div id={options[0].containerId} {...(cls ? { className: "adfox" } : {})} />;
    }
}

export default withContext(AdFoxAdaptive);
